// This is a magic string replaced by rollup

const SDK_VERSION = "8.45.1" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
